import { getStyled } from './styles';

const MainHeaderButtonsWrapper = ({ children }) => {
  const classes = getStyled();

  return <div style={classes.MainHeaderButtonsWrapper}>{children}</div>;
};

export default MainHeaderButtonsWrapper;
